import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import { initAnalyticsPageExitFlush, trackPageView } from '../analytics/tracker';

/**
 * Central route observer: records initial loads, SPA navigations, refresh and
 * back/forward without duplicate events from Strict Mode re-renders.
 */
export const useAnalyticsPageTracker = (): void => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const lastSentRef = useRef<string | null>(null);

  useEffect(() => initAnalyticsPageExitFlush(), []);

  useEffect(() => {
    const key = `${navigationType}|${location.pathname}|${location.search}|${location.key}`;
    if (lastSentRef.current === key) return;
    lastSentRef.current = key;
    trackPageView(location.pathname, location.search);
  }, [location.pathname, location.search, location.key, navigationType]);
};
